define("discourse/plugins/discourse-canned-replies/components/canned-replies-form", ["exports", "@ember/component"], function (_exports, _component) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({});

  _exports.default = _default;
});
define("discourse/plugins/discourse-canned-replies/components/canned-reply", ["exports", "@ember/component", "discourse/lib/show-modal", "discourse/plugins/discourse-canned-replies/lib/apply-reply", "discourse-common/lib/get-owner"], function (_exports, _component, _showModal, _applyReply, _getOwner) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _component.default.extend({
    canEdit: false,
    init: function init() {
      this._super.apply(this, arguments);

      var currentUser = this.get("currentUser");
      var everyoneCanEdit = this.get("siteSettings.canned_replies_everyone_enabled") && this.get("siteSettings.canned_replies_everyone_can_edit");
      var currentUserCanEdit = this.get("siteSettings.canned_replies_enabled") && currentUser && currentUser.can_edit_canned_replies;
      var canEdit = currentUserCanEdit ? currentUserCanEdit : everyoneCanEdit;
      this.set("canEdit", canEdit);
    },
    actions: {
      apply: function apply() {
        var composer = (0, _getOwner.getOwner)(this).lookup("controller:composer");
        (0, _applyReply.default)(this.get("reply.id"), this.get("reply.title"), this.get("reply.content"), composer.model);
        this.appEvents.trigger("canned-replies:hide");
      },
      editReply: function editReply() {
        var composer = (0, _getOwner.getOwner)(this).lookup("controller:composer");
        composer.send("closeModal");
        (0, _showModal.default)("edit-reply").setProperties({
          composerModel: composer.composerModel,
          replyId: this.get("reply.id"),
          replyTitle: this.get("reply.title"),
          replyContent: this.get("reply.content")
        });
      }
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-canned-replies/connectors/editor-preview/canned-replies", ["exports", "discourse/lib/show-modal", "discourse/lib/ajax", "discourse/lib/ajax-error", "discourse-common/lib/get-owner", "@ember/runloop"], function (_exports, _showModal, _ajax, _ajaxError, _getOwner, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    setupComponent: function setupComponent(args, component) {
      var currentUser = this.get("currentUser");
      var everyoneCanEdit = this.get("siteSettings.canned_replies_everyone_enabled") && this.get("siteSettings.canned_replies_everyone_can_edit");
      var currentUserCanEdit = this.get("siteSettings.canned_replies_enabled") && currentUser && currentUser.can_edit_canned_replies;
      var canEdit = currentUserCanEdit ? currentUserCanEdit : everyoneCanEdit;
      this.set("canEdit", canEdit);
      component.setProperties({
        cannedVisible: false,
        loadingReplies: false,
        replies: [],
        filteredReplies: []
      });

      if (!component.appEvents.has("canned-replies:show")) {
        this.showCanned = function () {
          return component.send("show");
        };

        component.appEvents.on("canned-replies:show", this, this.showCanned);
      }

      if (!component.appEvents.has("canned-replies:hide")) {
        this.hideCanned = function () {
          return component.send("hide");
        };

        component.appEvents.on("canned-replies:hide", this, this.hideCanned);
      }

      component.addObserver("listFilter", function () {
        var filterTitle = component.listFilter.toLowerCase();
        var filtered = component.replies.map(function (reply) {
          /* Give a relevant score to each reply. */
          reply.score = 0;

          if (reply.title.toLowerCase().indexOf(filterTitle) !== -1) {
            reply.score += 2;
          } else if (reply.content.toLowerCase().indexOf(filterTitle) !== -1) {
            reply.score += 1;
          }

          return reply;
        }).filter(function (reply) {
          return reply.score !== 0;
        }) // Filter irrelevant replies.
        .sort(function (a, b) {
          /* Sort replies by relevance and title. */
          if (a.score !== b.score) {
            return a.score > b.score ? -1 : 1;
            /* descending */
          } else if (a.title !== b.title) {
            return a.title < b.title ? -1 : 1;
            /* ascending */
          }

          return 0;
        });
        component.set("filteredReplies", filtered);
      });
    },
    teardownComponent: function teardownComponent(component) {
      if (component.appEvents.has("canned-replies:show") && this.showCanned) {
        component.appEvents.off("canned-replies:show", this, this.showCanned);
        component.appEvents.off("canned-replies:hide", this, this.hideCanned);
      }
    },
    actions: {
      show: function show() {
        var _this = this;

        $("#reply-control .d-editor-preview-wrapper > .d-editor-preview").hide();
        this.setProperties({
          cannedVisible: true,
          loadingReplies: true
        });
        (0, _ajax.ajax)("/canned_replies").then(function (results) {
          _this.setProperties({
            replies: results.replies,
            filteredReplies: results.replies
          });
        }).catch(_ajaxError.popupAjaxError).finally(function () {
          _this.set("loadingReplies", false);

          if (_this.canEdit) {
            (0, _runloop.schedule)("afterRender", function () {
              return document.querySelector(".canned-replies-filter").focus();
            });
          }
        });
      },
      hide: function hide() {
        $(".d-editor-preview-wrapper > .d-editor-preview").show();
        this.set("cannedVisible", false);
      },
      newReply: function newReply() {
        var composer = (0, _getOwner.getOwner)(this).lookup("controller:composer");
        composer.send("closeModal");
        (0, _showModal.default)("new-reply").set("newContent", composer.model.reply);
      }
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-canned-replies/controllers/canned-replies", ["exports", "@ember/controller", "discourse/mixins/modal-functionality", "discourse/lib/show-modal", "discourse/lib/ajax", "discourse-common/utils/decorators", "discourse/lib/ajax-error", "discourse/plugins/discourse-canned-replies/lib/apply-reply"], function (_exports, _controller, _modalFunctionality, _showModal, _ajax, _decorators, _ajaxError, _applyReply) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _controller.default.extend(_modalFunctionality.default, (_dec = (0, _decorators.observes)("selectedReplyId"), (_obj = {
    selectedReply: null,
    selectedReplyId: "",
    loadingReplies: true,
    canEdit: false,
    init: function init() {
      this._super.apply(this, arguments);

      var currentUser = this.get("currentUser");
      var everyoneCanEdit = this.siteSettings.canned_replies_everyone_enabled && this.siteSettings.canned_replies_everyone_can_edit;
      var currentUserCanEdit = this.siteSettings.canned_replies_enabled && currentUser && currentUser.can_edit_canned_replies;
      var canEdit = currentUserCanEdit ? currentUserCanEdit : everyoneCanEdit;
      this.set("canEdit", canEdit);
      this.replies = [];
    },
    _updateSelection: function _updateSelection() {
      this.selectionChange();
    },
    onShow: function onShow() {
      var _this = this;

      (0, _ajax.ajax)("/canned_replies").then(function (results) {
        _this.set("replies", results.replies); // trigger update of the selected reply


        _this.selectionChange();
      }).catch(_ajaxError.popupAjaxError).finally(function () {
        return _this.set("loadingReplies", false);
      });
    },
    selectionChange: function selectionChange() {
      var localSelectedReplyId = this.get("selectedReplyId");
      var localSelectedReply = "";
      this.get("replies").forEach(function (entry) {
        if (entry.id === localSelectedReplyId) {
          localSelectedReply = entry;
          return;
        }
      });
      this.set("selectedReply", localSelectedReply);
    },
    actions: {
      apply: function apply() {
        (0, _applyReply.default)(this.get("selectedReplyId"), this.selectedReply.title, this.selectedReply.content, this.composerModel);
        this.send("closeModal");
      },
      newReply: function newReply() {
        this.send("closeModal");
        (0, _showModal.default)("new-reply").set("newContent", this.composerModel.reply);
      },
      editReply: function editReply() {
        this.send("closeModal");
        (0, _showModal.default)("edit-reply").setProperties({
          replyId: this.selectedReplyId,
          replyTitle: this.get("selectedReply.title"),
          replyContent: this.get("selectedReply.content")
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "_updateSelection", [_dec], Object.getOwnPropertyDescriptor(_obj, "_updateSelection"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-canned-replies/controllers/edit-reply", ["exports", "@ember/controller", "discourse/mixins/modal-functionality", "discourse/lib/show-modal", "discourse/lib/ajax", "discourse-common/utils/decorators", "discourse/lib/ajax-error", "I18n", "bootbox"], function (_exports, _controller, _modalFunctionality, _showModal, _ajax, _decorators, _ajaxError, _I18n, _bootbox) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _controller.default.extend(_modalFunctionality.default, (_dec = (0, _decorators.default)("saving"), _dec2 = (0, _decorators.default)("replyTitle", "replyContent", "saving"), (_obj = {
    replyTitle: "",
    replyContent: "",
    replyId: "",
    saving: null,
    onShow: function onShow() {
      this.set("saving", null);
    },
    savingLabel: function savingLabel(saving) {
      return saving === null ? "save" : saving ? "saving" : "saved";
    },
    disableSaveButton: function disableSaveButton(replyTitle, replyContent, saving) {
      return saving || replyTitle === "" || replyContent === "";
    },
    actions: {
      save: function save() {
        var _this = this;

        this.set("saving", true);
        (0, _ajax.ajax)("/canned_replies/".concat(this.replyId), {
          type: "PATCH",
          data: {
            title: this.replyTitle,
            content: this.replyContent
          }
        }).catch(_ajaxError.popupAjaxError).finally(function () {
          _this.set("saving", false);

          _this.appEvents.trigger("canned-replies:show");
        });
      },
      remove: function remove() {
        var _this2 = this;

        _bootbox.default.confirm(_I18n.default.t("canned_replies.edit.remove_confirm"), function (result) {
          if (result) {
            (0, _ajax.ajax)("/canned_replies/".concat(_this2.replyId), {
              type: "DELETE"
            }).then(function () {
              _this2.send("closeModal");

              if (_this2.site.mobileView) {
                (0, _showModal.default)("canned-replies");
              } else {
                _this2.appEvents.trigger("canned-replies:show");
              }
            }).catch(_ajaxError.popupAjaxError);
          }
        });
      },
      cancel: function cancel() {
        this.send("closeModal");

        if (this.site.mobileView) {
          (0, _showModal.default)("canned-replies");
        } else {
          this.appEvents.trigger("canned-replies:show");
        }
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "savingLabel", [_dec], Object.getOwnPropertyDescriptor(_obj, "savingLabel"), _obj), _applyDecoratedDescriptor(_obj, "disableSaveButton", [_dec2], Object.getOwnPropertyDescriptor(_obj, "disableSaveButton"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-canned-replies/controllers/new-reply", ["exports", "@ember/controller", "discourse/mixins/modal-functionality", "discourse/lib/show-modal", "discourse/lib/ajax", "discourse-common/utils/decorators", "discourse/lib/ajax-error"], function (_exports, _controller, _modalFunctionality, _showModal, _ajax, _decorators, _ajaxError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _controller.default.extend(_modalFunctionality.default, (_dec = (0, _decorators.default)("newTitle", "newContent"), (_obj = {
    newTitle: "",
    newContent: "",
    onShow: function onShow() {
      this.setProperties({
        newTitle: "",
        newContent: ""
      });
    },
    disableSaveButton: function disableSaveButton(newTitle, newContent) {
      return newTitle === "" || newContent === "";
    },
    actions: {
      save: function save() {
        var _this = this;

        (0, _ajax.ajax)("/canned_replies", {
          type: "POST",
          data: {
            title: this.newTitle,
            content: this.newContent
          }
        }).then(function () {
          _this.send("closeModal");

          if (_this.site.mobileView) {
            (0, _showModal.default)("canned-replies");
          } else {
            _this.appEvents.trigger("canned-replies:show");
          }
        }).catch(_ajaxError.popupAjaxError);
      },
      cancel: function cancel() {
        this.send("closeModal");

        if (this.site.mobileView) {
          (0, _showModal.default)("canned-replies");
        } else {
          this.appEvents.trigger("canned-replies:show");
        }
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "disableSaveButton", [_dec], Object.getOwnPropertyDescriptor(_obj, "disableSaveButton"), _obj)), _obj)));

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/components/canned-replies-form"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,\"form\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"canned-replies-title-input-wrapper\"],[12],[1,\"\\n    \"],[10,\"label\"],[12],[10,\"strong\"],[12],[1,[28,[35,0],[\"canned_replies.title.name\"],null]],[13],[13],[1,\"\\n    \"],[1,[28,[35,1],null,[[\"class\",\"value\"],[\"canned-replies-form-title-input\",[33,2]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"canned-replies-form-content-wrapper\"],[12],[1,\"\\n    \"],[10,\"label\"],[12],[10,\"strong\"],[12],[1,[28,[35,0],[\"canned_replies.content.name\"],null]],[13],[13],[1,\"\\n    \"],[1,[28,[35,3],null,[[\"class\",\"value\"],[\"canned-replies-form-content-input\",[33,4]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[\"i18n\",\"input\",\"title\",\"d-editor\",\"content\"]]","moduleName":"javascripts/discourse/templates/components/canned-replies-form","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/canned-reply"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,\"details\"],[14,0,\"canned-reply\"],[15,1,[29,[\"canned-reply-\",[33,0,[\"id\"]]]]],[12],[1,\"\\n  \"],[10,\"summary\"],[14,0,\"canned-reply-title\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"canned-reply-title-text\"],[12],[1,[33,0,[\"title\"]]],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"actions\"],[12],[1,\"\\n      \"],[1,[28,[35,1],null,[[\"class\",\"action\",\"icon\"],[\"canned-replies-apply\",[28,[37,2],[[30,0],\"apply\"],null],\"far-clipboard\"]]]],[1,\"\\n\\n\"],[41,[33,4],[[[1,\"        \"],[1,[28,[35,1],null,[[\"class\",\"action\",\"icon\"],[\"canned-replies-edit\",[28,[37,2],[[30,0],\"editReply\"],null],\"pencil-alt\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"canned-replies-content\"],[12],[1,\"\\n    \"],[1,[28,[35,5],[[33,0,[\"content\"]]],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[\"reply\",\"d-button\",\"action\",\"if\",\"canEdit\",\"cook-text\"]]","moduleName":"javascripts/discourse/templates/components/canned-reply","isStrictMode":false});
Ember.TEMPLATES["javascripts/connectors/editor-preview/canned-replies"] = Ember.HTMLBars.template({"id":null,"block":"[[[41,[33,1],[[[1,\"  \"],[10,0],[14,0,\"d-editor-preview\"],[12],[1,\"\\n\"],[6,[39,2],null,[[\"condition\"],[[33,3]]],[[\"default\"],[[[[41,[33,4],[[[1,\"        \"],[10,0],[14,0,\"canned-replies-edit-bar\"],[12],[1,\"\\n          \"],[1,[28,[35,5],null,[[\"class\",\"action\",\"icon\",\"label\"],[\"canned-replies-new\",[28,[37,6],[[30,0],\"newReply\"],null],\"plus\",\"canned_replies.insert.new_button\"]]]],[1,\"\\n          \"],[1,[28,[35,7],null,[[\"class\",\"value\",\"placeholder\"],[\"canned-replies-filter\",[33,8],[28,[37,9],[\"canned_replies.filter_hint\"],null]]]]],[1,\"\\n\\n          \"],[1,[28,[35,5],null,[[\"class\",\"action\",\"icon\"],[\"modal-close close btn-flat\",[28,[37,6],[[30,0],\"hide\"],null],\"times\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[42,[28,[37,11],[[28,[37,11],[[33,12]],null]],null],null,[[[1,\"        \"],[1,[28,[35,13],null,[[\"reply\"],[[30,1]]]]],[1,\"\\n\"]],[1]],null]],[]]]]],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"r\"],false,[\"if\",\"cannedVisible\",\"conditional-loading-spinner\",\"loadingReplies\",\"canEdit\",\"d-button\",\"action\",\"text-field\",\"listFilter\",\"i18n\",\"each\",\"-track-array\",\"filteredReplies\",\"canned-reply\"]]","moduleName":"javascripts/discourse/templates/connectors/editor-preview/canned-replies","isStrictMode":false});
Ember.TEMPLATES["javascripts/modal/canned-replies"] = Ember.HTMLBars.template({"id":null,"block":"[[[6,[39,0],null,[[\"title\",\"class\",\"style\"],[\"canned_replies.insert.modal_title\",\"canned-replies-modal\",\"overflow: visible\"]],[[\"default\"],[[[[6,[39,1],null,[[\"condition\"],[[33,2]]],[[\"default\"],[[[[1,\"    \"],[10,0],[14,0,\"details\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"reply-selector\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"selector\"],[12],[1,\"\\n          \"],[1,[28,[35,3],null,[[\"id\",\"valueAttribute\",\"value\",\"nameProperty\",\"content\",\"none\"],[\"canned-replies-combobox\",\"id\",[33,4],\"title\",[33,5],\"canned_replies.insert.choose\"]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[33,7],[[[1,\"        \"],[10,0],[14,0,\"content\"],[12],[1,\"\\n          \"],[10,0],[12],[1,[28,[35,8],[[33,7,[\"content\"]]],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]]]]]],[]]]]],[1,\"\\n\"],[10,0],[14,0,\"modal-footer\"],[12],[1,\"\\n\"],[41,[33,9],[[[1,\"    \"],[1,[28,[35,10],null,[[\"class\",\"action\",\"icon\",\"label\"],[\"pull-left canned-replies-new\",[28,[37,11],[[30,0],\"newReply\"],null],\"plus\",\"canned_replies.insert.new_button\"]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[33,7],[[[41,[33,9],[[[1,\"      \"],[1,[28,[35,10],null,[[\"class\",\"action\",\"icon\",\"label\"],[\"pull-left canned-replies-edit\",[28,[37,11],[[30,0],\"editReply\"],null],\"pencil-alt\",\"canned_replies.insert.edit_button\"]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[1,[28,[35,10],null,[[\"class\",\"action\",\"icon\",\"label\"],[\"btn-primary pull-right canned-replies-apply\",[28,[37,11],[[30,0],\"apply\"],null],\"far-clipboard\",\"canned_replies.insert.insert_button\"]]]],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[],false,[\"d-modal-body\",\"conditional-loading-spinner\",\"loadingReplies\",\"combo-box\",\"selectedReplyId\",\"replies\",\"if\",\"selectedReply\",\"cook-text\",\"canEdit\",\"d-button\",\"action\"]]","moduleName":"javascripts/discourse/templates/modal/canned-replies","isStrictMode":false});
Ember.TEMPLATES["javascripts/modal/edit-reply"] = Ember.HTMLBars.template({"id":null,"block":"[[[6,[39,0],null,[[\"title\",\"class\"],[\"canned_replies.edit.modal_title\",\"canned-replies-modal\"]],[[\"default\"],[[[[1,\"  \"],[1,[28,[35,1],null,[[\"title\",\"content\"],[[33,2],[33,3]]]]],[1,\"\\n\"]],[]]]]],[1,\"\\n\"],[10,0],[14,0,\"modal-footer canned-replies-footer\"],[12],[1,\"\\n  \"],[1,[28,[35,4],null,[[\"class\",\"action\",\"label\",\"disabled\"],[\"btn-primary edit-reply-save-btn\",[28,[37,5],[[30,0],\"save\"],null],[33,6],[33,7]]]]],[1,\"\\n\\n  \"],[1,[28,[35,4],null,[[\"action\",\"icon\",\"label\",\"class\"],[[28,[37,5],[[30,0],\"cancel\"],null],\"chevron-left\",\"canned_replies.back\",\"canned-replies-edit-back\"]]]],[1,\"\\n\\n  \"],[1,[28,[35,4],null,[[\"class\",\"action\",\"icon\",\"disabled\"],[\"btn-danger\",[28,[37,5],[[30,0],\"remove\"],null],\"trash-alt\",[33,8]]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[\"d-modal-body\",\"canned-replies-form\",\"replyTitle\",\"replyContent\",\"d-button\",\"action\",\"savingLabel\",\"disableSaveButton\",\"saving\"]]","moduleName":"javascripts/discourse/templates/modal/edit-reply","isStrictMode":false});
Ember.TEMPLATES["javascripts/modal/new-reply"] = Ember.HTMLBars.template({"id":null,"block":"[[[6,[39,0],null,[[\"title\",\"class\"],[\"canned_replies.add.modal_title\",\"canned-replies-modal\"]],[[\"default\"],[[[[1,\"  \"],[1,[28,[35,1],null,[[\"title\",\"content\"],[[33,2],[33,3]]]]],[1,\"\\n\"]],[]]]]],[1,\"\\n\"],[10,0],[14,0,\"modal-footer canned-replies-footer\"],[12],[1,\"\\n  \"],[1,[28,[35,4],null,[[\"class\",\"action\",\"label\",\"disabled\"],[\"btn-primary new-reply-save-btn\",[28,[37,5],[[30,0],\"save\"],null],\"save\",[33,6]]]]],[1,\"\\n\\n\"],[13],[1,\"\\n\"]],[],false,[\"d-modal-body\",\"canned-replies-form\",\"newTitle\",\"newContent\",\"d-button\",\"action\",\"disableSaveButton\"]]","moduleName":"javascripts/discourse/templates/modal/new-reply","isStrictMode":false});
define("discourse/plugins/discourse-canned-replies/initializers/add-canned-replies-ui-builder", ["exports", "discourse/lib/plugin-api", "discourse/lib/show-modal"], function (_exports, _pluginApi, _showModal) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function initializeCannedRepliesUIBuilder(api) {
    api.modifyClass("controller:composer", {
      pluginId: "discourse-canned-replies",
      actions: {
        showCannedRepliesButton: function showCannedRepliesButton() {
          if (this.site.mobileView) {
            (0, _showModal.default)("canned-replies").set("composerModel", this.model);
          } else {
            this.appEvents.trigger("composer:show-preview");
            this.appEvents.trigger("canned-replies:show");
          }
        }
      }
    });
    api.addToolbarPopupMenuOptionsCallback(function () {
      return {
        id: "canned_replies_button",
        icon: "far-clipboard",
        action: "showCannedRepliesButton",
        label: "canned_replies.composer_button_text"
      };
    });
  }

  var _default = {
    name: "add-canned-replies-ui-builder",
    initialize: function initialize(container) {
      var siteSettings = container.lookup("site-settings:main");
      var currentUser = container.lookup("current-user:main");

      if (siteSettings.canned_replies_enabled && currentUser && currentUser.can_use_canned_replies) {
        (0, _pluginApi.withPluginApi)("0.5", initializeCannedRepliesUIBuilder);
      }
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-canned-replies/lib/apply-reply", ["exports", "discourse/lib/ajax", "discourse/lib/ajax-error"], function (_exports, _ajax, _ajaxError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _default;

  function _default(replyId, replyTitle, replyContent, model) {
    // Replace variables with values.
    if (model) {
      var vars = {
        my_username: model.get("user.username"),
        my_name: model.get("user.name"),
        original_poster_username: model.get("topic.details.created_by.username"),
        original_poster_name: model.get("topic.details.created_by.name"),
        reply_to_username: model.get("post.username"),
        reply_to_name: model.get("post.name"),
        last_poster_username: model.get("topic.last_poster_username"),
        reply_to_or_last_poster_username: model.get("post.username") || model.get("topic.last_poster_username")
      };

      for (var key in vars) {
        if (vars[key]) {
          replyTitle = replyTitle.replace(new RegExp("%{".concat(key, "(,fallback:.[^}]*)?}"), "g"), vars[key]);
          replyContent = replyContent.replace(new RegExp("%{".concat(key, "(,fallback:.[^}]*)?}"), "g"), vars[key]);
        } else {
          replyTitle = replyTitle.replace(new RegExp("%{".concat(key, ",fallback:(.[^}]*)}"), "g"), "$1");
          replyTitle = replyTitle.replace(new RegExp("%{".concat(key, "}"), "g"), "");
          replyContent = replyContent.replace(new RegExp("%{".concat(key, ",fallback:(.[^}]*)}"), "g"), "$1");
          replyContent = replyContent.replace(new RegExp("%{".concat(key, "}"), "g"), "");
        }
      }
    } // Finally insert canned reply.


    model.appEvents.trigger("composer:insert-block", replyContent);

    if (model && !model.title) {
      model.set("title", replyTitle);
    }

    (0, _ajax.ajax)("/canned_replies/".concat(replyId, "/use"), {
      type: "PATCH"
    }).catch(_ajaxError.popupAjaxError);
  }
});

